import $ from "jquery";

document.addEventListener("DOMContentLoaded", function(event) {
    $('.toggleElement').on('click', function() {
        let forElement = $('#' + $(this).data('forElement'));
        forElement.prop('hidden', !forElement.prop('hidden'));
    });
});